type FooterLink = { href: string; label?: string; external?: boolean };
export type FooterColumnKey =
  | 'services'
  | 'technologies'
  | 'aiAgents'
  | 'industries'
  | 'hire'
  | 'portfolio'
  | 'company'
  | 'resources';

export type FooterColumn = { titleKey: FooterColumnKey; links: FooterLink[] };

export const footerColumns: FooterColumn[] = [
  {
    titleKey: 'services',
    links: [
      { href: '/services/full-cycle' },
      { href: '/services/advanced-tech' },
      { href: '/services/full-cycle/web-development' },
      { href: '/services/full-cycle/mobile-development' },
      { href: '/services/full-cycle/ui-ux-design' },
      { href: '/services/full-cycle/cloud-development' },
      { href: '/services/full-cycle/erp-development' },
      { href: '/services/full-cycle/devops' },
    ],
  },
  {
    titleKey: 'technologies',
    links: [
      { href: '/technologies/frontend' },
      { href: '/technologies/backend' },
      { href: '/technologies/mobile' },
      { href: '/technologies/cloud' },
      { href: '/technologies/erp-crm' },
      { href: '/technologies/data-ai-ml' },
      { href: '/technologies/devops-data' },
    ],
  },
  {
    titleKey: 'aiAgents',
    links: [
      { href: '/ai-agents/strategy' },
      { href: '/ai-agents/generative-ai' },
      { href: '/ai-agents/llm-rag' },
      { href: '/ai-agents/agents' },
      { href: '/ai-agents/trust' },
      { href: '/ai-agents/compliance' },
    ],
  },
  {
    titleKey: 'industries',
    links: [
      { href: '/industries/bfsi' },
      { href: '/industries/health-life-sciences' },
      { href: '/industries/retail-consumer' },
      { href: '/industries/technology-telecom' },
      { href: '/industries/manufacturing-mobility' },
      { href: '/industries/logistics-supply-chain' },
      { href: '/industries/government-public' },
      { href: '/industries/energy-resources' },
    ],
  },
  {
    titleKey: 'hire',
    links: [
      { href: '/hire/dedicated-developers' },
      { href: '/hire/staff-augmentation' },
      { href: '/hire/offshore-developers' },
      { href: '/hire/web-developers' },
      { href: '/hire/mobile-developers' },
      { href: '/hire/other-engineers' },
    ],
  },
  {
    titleKey: 'portfolio',
    links: [
      { href: '/portfolio/case-studies' },
      { href: '/portfolio/platforms' },
    ],
  },
  {
    titleKey: 'company',
    links: [
      { href: '/about' },
      { href: '/consultation' },
      { href: '/careers' },
    ],
  },
  {
    titleKey: 'resources',
    links: [
      { href: '/blog' },
      { href: '/help' },
      { href: '/privacy' },
    ],
  },
];
